module.exports = __webpack_public_path__ + "static/media/tag-icon.72cd15b7.svg";